import React, { Component } from 'react';
import { ROUTES } from '../../constants/routes';
import BuyPageContent from '../NewCertificateBuyPage/Content/index';
import styles from './NewPaymentCertificatePage.module.scss';
import { ELEMENTS_IDS } from '../../constants/labels';

const LIQPAY_LIB = 'liqpayCheckoutLib';
const LIQPAY_STATUSES = {
  SUCCESS: 'success',
  WAIT_COMPENSATION: 'wait_compensation',
};

function isSuccess(status) {
  return (
    status === LIQPAY_STATUSES.SUCCESS ||
    status === LIQPAY_STATUSES.WAIT_COMPENSATION
  );
}

export default class NewPaymentCertificatePage extends Component {
  componentDidMount() {
    const {
      paymentIntentionData,
      campaignData = { language: 'UK' },
    } = this.props;

    window.LiqPayCheckoutCallback = () => {
      window.LiqPayCheckout &&
        window.LiqPayCheckout.init({
          mode: 'embed',
          embedTo: `#${ELEMENTS_IDS.PAYMENT_FORM}`,
          data: paymentIntentionData.data,
          signature: paymentIntentionData.signature,
          language: campaignData.language.toLowerCase(),
        }).on('liqpay.callback', this.handleSuccess);
    };

    this.createLiqpayScript();
  }

  componentWillUnmount() {
    this.deleteLiqpayScript();
  }

  deleteLiqpayScript = () => {
    const liqpayScript = document.getElementById(LIQPAY_LIB);

    liqpayScript.remove();
  };

  createLiqpayScript = () => {
    const script = document.createElement('script');

    script.setAttribute('id', LIQPAY_LIB);

    script.src = '//static.liqpay.ua/libjs/checkout.js';
    script.async = true;

    document.body.appendChild(script);
  };

  handleSuccess = data => {
    const { certificateData, showSuccessPaymentScreen } = this.props;

    if (data) {
      const { status } = data;

      if (isSuccess(status)) {
        showSuccessPaymentScreen({
          campaignId: certificateData.campaignId,
          certificateId: certificateData.id,
        });
      }
    }
  };

  render() {
    const {
      history,
      paymentIntentionData,
      campaignData: { identifier, backgroundColor },
    } = this.props;

    if (!paymentIntentionData || !paymentIntentionData.signature) {
      history.push(ROUTES.USER_LANDING.replace(':id', identifier));

      return null;
    }

    return (
      <div className={styles.buyCertificatePage} style={{ backgroundColor }}>
        <BuyPageContent />
        <div className={styles.paymentWidget} id={ELEMENTS_IDS.PAYMENT_FORM} />
      </div>
    );
  }
}
